// React
import React from 'react';
// External
// import S3 from 'aws-s3';
import AWS from 'aws-sdk';
import { withRouter } from 'react-router-dom';
import {
    Col, Container, Form, Row
} from 'react-bootstrap';
import { connect } from 'react-redux';
import moment from 'moment';
import Q from 'q';
// Image
import spinner from 'assets/icons/spinner.svg';
// Internal
import { updateEngraving } from 'stores/actions';
import { uploadEngraving, getBooking } from 'services/booking';
import VesselImage from 'components/shared/atoms/VesselImage/VesselImage';
import EngravingImages from 'components/shared/atoms/EngravingImages/EngravingImages';
import PreResizedImage from 'components/shared/organisms/PreResizedImage/PreResizedImage';
import config from 'config/config';
// Style
import './styles.scss';

class FinalApproval extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [],
            engraving: null,
            savedImage: null,
            vesselImage: null,
            isApproved: false,
            isPageLoading: false
        };

        this.checkBoxSvg = (
            <svg
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2.4346 12.9543L6.08322 18.2926L19.89 2.43565"
                    stroke="#4F868E"
                    strokeWidth="3.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    async componentDidMount() {
        const modalTitle = document.getElementsByClassName('modal-title')[0];
        if (typeof modalTitle !== 'undefined') {
            modalTitle.scrollIntoView();
        }
        const navbarBrand = document.getElementsByClassName('navbar-brand')[0];
        if (typeof navbarBrand !== 'undefined') {
            navbarBrand.scrollIntoView();
        }
        const vesselImage = await VesselImage(this.props.engraving.productId);
        this.setState({
            engraving: this.props.engraving.engravingOptionsImage,
            savedImage: this.props.engraving.imageOptions.croppedImage,
            vesselImage
        }, () => {
            this.calculateCanvasSize();
        });
    }

    async handleSubmit() {
        const errors = [];

        if (!this.state.isApproved) {
            errors.push('icon');
        }

        await this.setError(errors);

        if (this.state.errors.length !== 0) {
            alert('Please check the green approval checkbox');
            return;
        }

        const engraving = {
            ...this.props.engraving,
            customTextImage: '',
            engravingOptionsImage: '',
            imageOptions: {
                ...this.props.engraving.imageOptions,
                croppedImage: null,
                fileImgSrc: null
            },
            quotedProductId: {
                ...this.props.engraving.quotedProductId,
                engravingFiles: null
            }
        };

        this.setState({
            isPageLoading: true
        });

        const engravingOptionsUrl = await this.uploadToS3(
            this.props.engraving.engravingOptionsImage,
            'engraving-options'
        );
        const imageOptionsUrl = await this.uploadToS3(
            this.props.engraving.imageOptions.croppedImage,
            'image-options'
        );

        let actualProductId = '';

        await getBooking(this.props.engraving.bookingId)
            .then((response) => {
                if (response.data.actual_products.length > 0) {
                    actualProductId = response.data.actual_products[0].id;
                }
            }).catch((err) => {
                console.log(err);
                alert('Sorry, failed to retrieve product id');
            });

        if (actualProductId === '') {
            alert('Sorry, no product id');
        } else {
            await uploadEngraving(
                engraving.toSubmitFormat(imageOptionsUrl, engravingOptionsUrl),
                actualProductId
            ).then(() => {
                // Todo: handle response
            }).catch((err) => {
                console.error('err :>> ', err);
            }).finally(() => {
                this.setState({
                    isPageLoading: false
                },);
            });
        }

        return errors.length > 0 ? null : engraving;
    }

    handleApprovedChange(event) {
        const { target } = event;
        const value = target.checked;

        this.setState({
            isApproved: value
        });
    }

    setError(error) {
        this.setState({ errors: error });
    }

    // eslint-disable-next-line class-methods-use-this
    base64ToBlob(base64) {
        return fetch(base64)
            .then((res) => res.blob());
    }

    async uploadToS3(base64ImageStr, filename) {
        AWS.config.update({ region: config.AWS_S3.REGION });
        const s3Client = new AWS.S3({
            accessKeyId: config.AWS_S3.ACCESS_KEY,
            secretAccessKey: config.AWS_S3.SECRET_ACCESS_KEY
        });
        const params = {
            Bucket: config.AWS_S3.BUCKET,
            Key: `${config.AWS_S3.ENGRAVING_DIR}/${filename}${moment().format('YYYY-MM-DD-HH.mm.ss-x')}.png`,
            Body: await this.base64ToBlob(base64ImageStr)
        };
        try {
            const d = Q.defer();
            s3Client.upload(params, null, (err, data) => {
                if (err) {
                    console.log('Error', err);
                    d.reject(err);
                }
                d.resolve(data);
            });
            return d.promise;
        } catch (err) {
            return err;
        }
    }

    async calculateCanvasSize() {
        const stateSavedImage = this.state.savedImage;
        const resultImage = await PreResizedImage(stateSavedImage, 398);
        this.setState({
            savedImage: resultImage
        });

        if (this.state.vesselImage) {
            const stateVesselImage = this.state.vesselImage;
            const vesselResultImage = await PreResizedImage(stateVesselImage, 398);
            this.setState({
                vesselImage: vesselResultImage
            });
        }
    }

    render() {
        return this.state.isPageLoading ? (
            <img
                className="page-loading-icon"
                alt="Page Loading Icon"
                src={spinner}
            />
        ) : (
            <Container fluid className="engraving-container final-approval">
                <EngravingImages
                    engraving={this.state.engraving}
                    savedImage={this.state.savedImage}
                    vesselImage={this.state.vesselImage}
                />
                <Row>
                    <Col lg={5} className="col-12">
                        <div className="section-description">
                            <h5>Artwork approval</h5>
                            <p>
                                Before adding to your cart, please double check artwork to ensure all
                                text and imagery is correct.
                            </p>
                        </div>

                        <div className="final-approval-wrapper">
                            <Form className="final-approval-form">
                                <Form.Row>
                                    <Form.Group as={Col}>

                                        <label className="checkbox">
                                            <span className="checkbox__input">
                                                <input
                                                    type="checkbox"
                                                    name="checkbox"
                                                    onChange={(e) => this.handleApprovedChange(e)}
                                                />
                                                <span className="checkbox__control">
                                                    {this.checkBoxSvg}
                                                </span>
                                            </span>
                                            <span className="radio__label">
                                                Content has been checked and is correct
                                            </span>
                                        </label>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        engraving: state.engraving
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateEngraving: (engravingObj) => dispatch(updateEngraving(engravingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FinalApproval));
